import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ProjectsAdmin from "./ProjectsAdmin";
import UserAdmin from "./UserAdmin";
import ProjectDashboard from "./ProjectDashboard";
import TrashAdmin from "./TrashAdmin";
import MigrationAdmin from "./MigrationAdmin";
import DevfolioUserAccess from "./DevfolioUserAccess";
import AccessManagement from "./AccessManagement"; 

export default function AdminApp() {
  const location = useLocation();

  return (
    <div className="h-full overflow-hidden">
      <div className="h-full overflow-hidden bg-white dark:bg-[#0a0a0c] transition-colors duration-300">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.35, ease: "easeInOut" }}
            className="h-full overflow-auto p-6"
          >
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Navigate to="projects" replace />} />
              <Route path="projects" element={<ProjectsAdmin />} />
              <Route path="projects/:projectId" element={<ProjectDashboard />} />
              <Route path="access-management" element={<AccessManagement />} />
              <Route path="access-management/:projectId" element={<AccessManagement />} />
              <Route path="users" element={<UserAdmin />} />
              <Route path="devfolio-users" element={<DevfolioUserAccess />} />
              <Route path="trash" element={<TrashAdmin />} />
              <Route path="migration" element={<MigrationAdmin />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}

